export function ourSponsorsSlider() {
    $(".our-sponsors.has-slider").each(function () {
        $(this).infiniteslide({
            direction: "left",
            speed: 30,
            pauseonhover: false
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/ourSponsorsSlider.js